import { CloseButton, newToast, ValidationErrors, Stack, Typography, ListContextValue, ListContext } from "@compass/core";
import { SubmitButton } from "components";
import { Partner } from "generated/openApi";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { partnerCreatePageRoute } from "./PartnerCreatePage";
import { useNavigate } from "react-router-dom";
import { partnerPageRoute } from "../PartnerPage/PartnerPage";
import { useContext } from "react";

export const PartnerPageHeader = (props: {
  handle: string;
  partner: Partner;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);

  const save = (partner: Partner) => {
    props.setValidationErrors({});

    ApiService.partners
      .saveCreate(partner)
      .then((response) => {
        const id = response;
        navigate(`../${partnerPageRoute.getPath({ id: id, crudMode: "view" })}`);
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      })
      .catch((ex) => {
        dispatch(setAppToast(newToast("error")));
        props.setValidationErrors(ex.response);
      });
  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton confirm={props.unsavedChanges} />
        <SubmitButton onClick={() => save(props.partner)} disabled={props.partner.id > 0 && !props.unsavedChanges} />
      </Stack>
    </Stack>
  );
};
